import styles from '../Link/Link.module.css';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  onClick: () => void;
  disabled?: boolean;
};

export function ButtonLink(props: Props) {
  const { children, onClick, disabled = false } = props;

  return (
    <button onClick={onClick} className={styles.link} disabled={disabled}>
      {children}
    </button>
  );
}
